export const EMAIL_PATTERN = '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}' +
  '\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$';

export const NUMBER_PATTERN = /^-?\d*\.?\d{1,2}$/;
export const NUMBER_INT_POSITIVE = /^\d{1,}$/;
export const NUMBER_LENGTH_NINE = /^[0-9]{9}$/;
export const ALPHA_NUMERIC = /^[a-zA-Z0-9_]{1,34}$/;
export const NUMBER_LENGTH_TWENTY = /^[0-9]{1,20}$/;
export const TIME_PATTERN = /^[0-1][0-9]:[0-5][0-9] [AP]M$/;
export const TIME_PATTERN_M = /^([0-5]?[0-9])$/;
export const TIME_PATTERN_H = /^(0[1-9]|1[0-2]|[1-9])$/;
export const NUMBER_LIMIT_H = /^(0[1-9]|1[0-9]|2[0-4]|[1-9])$/;
export const PASSWORD_PATTERN = /^(?=.*[a-zA-Zа-яА-Я])((?=.*[0-9!@#$%^&*_,.]))(.{6,})/;
export const MIN_ONLY = /^[1-9]\d?[mM]?$|^0[mM]?$/;
export const IP_PATTERN = /[^0-9\,\.]+/g;
export const IMAGE_URL = 'file/';
export const FLOAT_PATTERN = /^-?\d*\.?\d{1,6}$/;
export const PHONE_NUMBER = /^(((\+\d{1,2}?\s?)?((\(\d{3}\))|\d{3}))|((\+\d{3}?\s?)?\d{2}))[\s\-]?\d{3}[\s\-]?\d{2}[\s\-]?\d{2}$/;
